import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { ThemeApiStructure } from "@interfaces/theme";

export const localTheme: ThemeApiStructure = {
  id: import.meta.env.VITE_ENV === "PROD" ? "" : "49f931c1-d705-4b02-a710-a5da2e0fdec1",
  name: "nafin",
  display_name: "Nafin",
  description: "",
  code: "",
  url_site: "/solicita_tu_credito",
  url_privacy_notice: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  url_terms_and_conditions: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  palette: {
    palette: {
      primary: {
        base: "#E2E8EA", // base 30%
        dark: "#00313D", // obscuro
        main: "#00718D", // color 2
        light: "#E2EAEA", // color 1
        accent: "#30A6B3", // accents
      },
      components: {},
    },
    interface: {
      navbar: {
        logo: "nafin/portal/logos/logo.png",
        logo_width: 130,
        logo_height: "auto",
      },
      lateral: {
        bg_dark: "#00313D",
        bg_light: "#00718D",
        logo_bg_dark: "nafin/portal/logos/logo_dark_bg.png",
        text_bg_dark: "#FFFFFF",
        logo_bg_light: "nafin/portal/logos/logo_dark_bg.png",
        text_bg_light: "#FFFFFF",
        logo_width: 200,
        logo_height: "auto",
      },
      metadata: {
        title: "Nafin",
        favicon: "nafin/portal/logos/favicon.ico",
      },
    },
  },
};

export const interfaceConfig: InterfaceConfig = {
  name: "nafin",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "Nafin",
    description:
      "Nafin es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "nafin/portal/logos/favicon.ico",
    ogImage: "https://demo-clientes-nafin.lendia.mx/opengraph-image.png?5ab5b324c6780cbc",
  },
  textos_tofu: {
    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
    },
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_BeRV6uYmO",
      userPoolClientId: "208j2kkvh8r32d2a9qq926t33f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Y0yNT5nH4",
      userPoolClientId: "78ctmcltm4h9r5g3lgie7fl65f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
